import { DevSettings, Platform } from "react-native";
import { atom, getDefaultStore } from "jotai";

/**
 * When true, App renders the on-device Storybook instead of the normal UI.
 * Kept in memory only: a reload of the app goes back to the normal UI.
 */
export const storybookModeAtom = atom(false);

export const openStorybook = () => {
    if (Platform.OS === "web") {
        return;
    }
    getDefaultStore().set(storybookModeAtom, true);
};

const toggleStorybook = () => {
    getDefaultStore().set(storybookModeAtom, (current) => !current);
};

let devMenuInitialized = false;

export const addStorybookToDevMenu = () => {
    if (!__DEV__ || Platform.OS === "web" || devMenuInitialized) {
        return;
    }
    devMenuInitialized = true;

    DevSettings.addMenuItem("Toggle Storybook", toggleStorybook);
    // expo-dev-client replaces the React Native dev menu, items must also be registered there
    try {
        const { registerDevMenuItems } = require("expo-dev-menu") as typeof import("expo-dev-menu");
        registerDevMenuItems([{ name: "Toggle Storybook", callback: toggleStorybook }]).catch(
            () => {},
        );
    } catch {
        // expo-dev-menu is only available in development builds
    }
};
